<template>
  <div class="wrap-box">
    <div class="wrap-box-left">
      <div class="article-wrap" style="height: 100%;">
        <div v-if="detail.id" class="centre_content nano" id="centre_contents">
          <div id="consult_left_content">
            <div class="table-top-box">
              <span class="fl left">{{ $t('label.information.multilateral.detailTitle') }}</span>
              <span class="fr right" @click="back()">
                <Icon type="ios-arrow-back" style="color:#1e98d3;font-size: 20px;" />{{ $t('buttons.back') }}
              </span>
              <span class="fr right div-xs-hidden" @click="exportDetail">
                <span class="word-png"></span>{{ $t('buttons.export') }}
              </span>
              <span class="fr right">
                <Icon
                  color="#008bce"
                  @click="editFavorite"
                  :type="detail.favStatus ? 'md-star' : 'md-star-outline'"
                  style="font-size: 20px;"/>
              </span>
            </div>
          </div>
          <div class="nano-content p-4" style="top:40px;padding-top: 0px !important;">
            <h1 class="information_article_headline">{{ detail.title }}</h1>
            <p class="information_article_info md-meta-line">
              <span class="md-meta-fixed mr-2">
                {{ $t('label.information.multilateral.publishTime') }}{{ detail.newsTime | formatDate(that) }}
              </span>
              <span v-if="sourceLabel" class="md-meta-fixed" style="margin: 0 15px;" :title="sourceFull">
                {{ $t('label.information.detail.source') }}{{ sourceLabel }}
              </span>
              <span v-if="orgLabel" class="md-meta-org" :title="orgFull">
                {{ $t('label.information.multilateral.org') }}：
                <b style="color:rgb(45,140,240)">{{ orgLabel }}</b>
              </span>
              <span v-if="tagLabel" class="md-meta-fixed" style="margin: 0 15px;">
                {{ $t('label.information.multilateral.infoType') }}：
                <b style="color:rgb(45,140,240)">{{ tagLabel }}</b>
              </span>
              <span v-if="categoryLabel" class="md-meta-fixed">
                {{ $t('label.information.multilateral.infoCategory') }}：
                <b style="color:rgb(45,140,240)">{{ categoryLabel }}</b>
              </span>
            </p>
            <div class="information_article_abstract rounded" v-if="detail.summary">
              <p>{{ $t('label.information.detail.summary') }}{{ detail.summary }}</p>
            </div>
            <div class="information_article_details text-indent2" v-html="contentHtml"></div>
            <p class="md-disclaimer">{{ $t('label.information.multilateral.disclaimer') }}</p>
            <p class="pbr-detail-box-link" v-if="detail.sourceaddress || detail.sourceAddress">
              <el-link type="primary" target="_blank" :underline="false" :href="detail.sourceaddress || detail.sourceAddress">
                {{ $t('label.information.detail.originalLink') }}
              </el-link>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="wrap-box-right">
      <div class="pbr-title">{{ $t('label.information.detail.relevantInformation') }}</div>
      <normal-list :page-size="6" :data="relatedList" goto="pbrMultilateralDetail"></normal-list>
    </div>
  </div>
</template>

<script>
import NormalList from '../index/NormalList.vue'
import { contentType, exportFile } from '../apis/common'
import {
  MD_DICT,
  MD_TAG_OPTIONS,
  MD_FALLBACK,
  findOptionLabel,
  mapDictItems
} from './multilateralOptions'

export default {
  name: 'pbrMultilateralDetail',
  components: { NormalList },
  data () {
    return {
      that: this,
      detail: {},
      relatedList: [],
      tagOptions: MD_TAG_OPTIONS.slice()
    }
  },
  computed: {
    isEN () {
      return localStorage.getItem('locale') === 'en'
    },
    lang () {
      return this.isEN ? 'en' : 'cn'
    },
    sourceNames () {
      return this.splitNames(this.detail.sourceType)
    },
    sourceLabel () {
      return this.limitNames(this.sourceNames)
    },
    sourceFull () {
      return this.sourceNames.join('、')
    },
    orgNames () {
      return this.splitNames(this.detail.orgNames)
    },
    orgLabel () {
      if (this.sourceNames.length > 2) return this.orgNames.join('、')
      return this.limitNames(this.orgNames)
    },
    orgFull () {
      return this.orgNames.join('、')
    },
    tagLabel () {
      return this.resolveLabels(this.detail.tagCode || this.detail.tagName, this.tagOptions)
    },
    categoryLabel () {
      return this.joinNames(this.detail.categoryName)
    },
    sourceNote () {
      const names = this.joinNames(this.detail.sourceType)
      return names ? `（${names}）` : ''
    },
    contentHtml () {
      const html = this.detail.content || ''
      const note = this.sourceNote
      if (!html || !note) return html
      return this.insertSourceNote(html, note)
    }
  },
  activated () {
    this.ensureDictLoaded().then(() => this.loadDetail())
  },
  mounted () {
    this.ensureDictLoaded().then(() => this.loadDetail())
  },
  methods: {
    ensureDictLoaded () {
      if (this._dictLoaded) return Promise.resolve()
      const jobs = [
        { dict: MD_DICT.tag, key: 'tagOptions' }
      ]
      return Promise.all(jobs.map(({ dict, key }) => {
        return this.$pbrApis.fetchMultilateralDictItems(dict).then(res => {
          const list = mapDictItems((res && res.result) || [])
          if (list.length) {
            this[key] = list
          } else if (MD_FALLBACK[dict]) {
            this[key] = MD_FALLBACK[dict].slice()
          }
        }).catch(() => {
          if (MD_FALLBACK[dict]) {
            this[key] = MD_FALLBACK[dict].slice()
          }
        })
      })).then(() => {
        this._dictLoaded = true
      })
    },
    splitNames (value) {
      if (value == null || value === '') return []
      return String(value).split(/[,，]/).map(s => s.trim()).filter(Boolean)
    },
    joinNames (value) {
      return this.splitNames(value).join('、')
    },
    limitNames (names, max = 2) {
      if (!names.length || names.length <= max) return names.join('、')
      return names.slice(0, max).join('、') + this.$t('label.information.multilateral.andMore')
    },
    insertSourceNote (html, note) {
      let lastPeriod = -1
      let inTag = false
      for (let i = 0; i < html.length; i++) {
        const ch = html[i]
        if (ch === '<') inTag = true
        else if (ch === '>') inTag = false
        else if (!inTag && ch === '。') lastPeriod = i
      }
      if (lastPeriod >= 0) {
        const after = html.slice(lastPeriod + 1).replace(/^\s+/, '')
        if (after.indexOf(note) === 0) return html
        return html.slice(0, lastPeriod + 1) + note + html.slice(lastPeriod + 1)
      }
      const trailing = html.match(/(?:\s*<\/[^>]+>)*\s*$/)
      const tail = trailing ? trailing[0] : ''
      if (!tail) return html + note
      return html.slice(0, html.length - tail.length) + note + tail
    },
    resolveLabels (codes, options) {
      if (!codes) return ''
      return String(codes).split(/[,，]/).filter(Boolean).map(c => findOptionLabel(options, c.trim(), this.isEN) || c.trim()).join('、')
    },
    loadDetail () {
      const id = this.$route.query.key
      if (!id) return
      this.$pbrApis.fetchMultilateralDynamicsDetail({
        id,
        lang: this.lang,
        from: this.lang
      }).then(res => {
        if (res && (res.success || res.code === 200)) {
          this.detail = res.result || {}
          this.loadRelated()
        }
      }).catch(() => {})
    },
    loadRelated () {
      const orgCodes = this.detail.orgCodes || ''
      this.$pbrApis.searchMultilateralDynamics({
        lang: this.lang,
        from: this.lang,
        searchkey: '',
        orgCodes,
        orderby: 'desc',
        orderkey: 'newsTime'
      }, { pageNo: 1, pageSize: 8 }).then(res => {
        if (res && (res.success || res.code === 200)) {
          const result = res.result || {}
          const list = result.content || result.records || result.list || []
          this.relatedList = list
            .filter(item => item.id !== this.detail.id)
            .slice(0, 6)
            .map(item => ({
              id: item.id,
              title: item.title,
              time: item.newsTime || item.articleDate
            }))
        }
      }).catch(() => {})
    },
    exportDetail () {
      const id = this.$route.query.key
      if (!id) return
      exportFile(
        this.$pbrApis.exportMultilateralDetailWordUrl,
        { id, from: this.lang, lang: this.lang },
        this.$t('label.export.multilateral') + (this.detail.title || ''),
        contentType.word,
        '.docx'
      )
    },
    editFavorite () {
      const type = this.detail.favStatus ? 'delete' : 'add'
      this.$pbrApis.editFavorite(type, { id: this.$route.query.key, type: 5 }).then(res => {
        if (res && res.code === 200) {
          this.loadDetail()
        }
      }).catch(() => {})
    },
    back () {
      this.$router.back()
    }
  },
  filters: {
    formatDate (value, vue) {
      if (value && value !== '--') {
        return vue.$moment(value).format('yyyy-MM-DD')
      }
      return value || ''
    }
  },
  watch: {
    '$route.query.key' () {
      this.loadDetail()
    }
  }
}
</script>

<style scoped>
.information_article_info.md-meta-line {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  line-height: 20px;
  overflow: hidden;
}
.md-meta-fixed {
  flex: 0 0 auto;
  white-space: nowrap;
}
.md-meta-org {
  flex: 0 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.md-disclaimer {
  margin-top: 16px;
  color: #808c9a;
  font-size: 13px;
  line-height: 1.8;
}
</style>
